import { render } from "./fpxf.vue?vue&type=template&id=2c1b9464"
import script from "./fpxf.vue?vue&type=script&lang=js"
export * from "./fpxf.vue?vue&type=script&lang=js"

import exportComponent from "/root/qzf/src/invoice-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__